import { ProductSuitabilityOption } from '__core/shared/model/tool/ProductSuitability.enum';
import template from './riskInsuranceCompliance.template.html';
import templateAddNewAddress from '../address/addNewAddress.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    compliance: '<',
    contacts: '<',
    addresses: '<',
    idTicket: '<',
    isTicketSettled: '<',
    onChanged: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdUtil,
      $mdMedia,
      $mdDialog,
      Address,
      YesNoOption,
      riskInsuranceService,
      helperService,
      eventService,
      financeService,
      financesService,
      RiskInsuranceCompliance,
      dateTimeService,
      GOOGLEMAPS
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.availableStates = [];
      ctrl.availableComplianceVerificationsInterviewDetailsMethods = [];
      ctrl.availableComplianceVerificationsEmploymentOptions = [];
      ctrl.availableYesNoOptionsOne = [];
      ctrl.availableYesNoSelectOptionsThree = [];
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.googleAutocompleteOptions = {
          componentRestrictions: GOOGLEMAPS.restrictToCountries
        };
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availableComplianceVerificationsInterviewDetailsMethods = helperService.getAvailableComplianceVerificationsInterviewDetailsMethods();
        ctrl.availableComplianceVerificationsEmploymentOptions = helperService.getAvailableComplianceVerificationsEmploymentOptions();
        ctrl.availableYesNoOptionsOne = helperService.getAvailableYesNoOptions({ option: 1 });
        ctrl.availableYesNoSelectOptionsThree = helperService.getAvailableYesNoSelectOptions({
          option: 3
        });
        ctrl.availableProductSuitabilityOptions = _.without(
          ProductSuitabilityOption.available() || [],
          ProductSuitabilityOption.none
        );
        ctrl.compliance = ctrl.compliance || {};
        ctrl.contacts = ctrl.contacts || [];
        ctrl.addresses = ctrl.addresses || [];
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;

        dateTimeService.getSet(
          ctrl,
          ctrl.compliance,
          'verifications.interviewDetails.date',
          'getSetVerificationsInterviewDetailsDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.compliance,
          'verifications.employmentVerification.date',
          'getSetVerificationsEmploymentVerificationDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.compliance,
          'verifications.incomeVerification.date',
          'getSetVerificationsIncomeVerificationDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.compliance,
          'verifications.livingExpenses.date',
          'getSetVerificationsLivingExpensesDate'
        );

        ctrl.getAllAddresses();
        if (!ctrl.isTicketSettled) {
          ctrl.isProcessing = true;
          ctrl.financeMonthlyFinancialPositionEstimate();
        }
        ctrl.isReady = true;
      };

      ctrl.getAllAddresses = () => {
        ctrl.interviewAddresses = [];
        const blankInterviewAddress = !ctrl.compliance?.verifications?.interviewDetails?.address
          ?.street
          ? Address.build(ctrl.compliance.verifications.interviewDetails?.address)
          : Address.blank();
        const allInterviewAddresses = angular.copy(ctrl.addresses);
        allInterviewAddresses.unshift(blankInterviewAddress);
        ctrl.interviewAddresses = _.compact(allInterviewAddresses);
      };

      ctrl.addNewVerificationsAddress = ($event, idx) => {
        $event.stopPropagation();
        $mdDialog
          .show({
            targetEvent: $event,
            locals: {
              index: idx,
              googleAutocompleteOptions: ctrl.googleAutocompleteOptions,
              availableStates: ctrl.availableStates,
              countries: ctrl.countries
            },
            template: templateAddNewAddress,
            controllerAs: '$ctrl',
            controller(index, googleAutocompleteOptions, availableStates, countries) {
              const ctr = this;
              ctr.idx = index;
              ctr.googleAutocompleteOptions = googleAutocompleteOptions;
              ctr.availableStates = availableStates;
              ctr.countries = countries;
              ctr.address = Address.blank();
              ctr.confirm = () => {
                $mdDialog.hide({ idx: ctr.idx, address: ctr.address });
              };
              ctr.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((result) => {
            if (
              result?.address &&
              result?.address?.streetNumber !== '' &&
              result?.address?.street &&
              (result?.address?.suburb || result?.address?.city) &&
              result?.address?.postCode
            ) {
              if (result.idx !== null) {
                ctrl.compliance.verifications.identities[idx].address = result.address;
              } else {
                ctrl.compliance.verifications.interviewDetailsLocation = result.address;
              }
              ctrl.addresses.push(result.address);
              ctrl.getAllAddresses();
              ctrl.riskInsuranceComplianceChanges(true);
            }
          });
      };

      ctrl.addressChanged = () => {
        ctrl.getAllAddresses();
        ctrl.riskInsuranceComplianceChanges(true);
      };

      ctrl.getAddress = (address) =>
        address?.street ? Address.getAddress(address) : 'Select one';

      ctrl.toggleConflictSuitability = (isConflict) => {
        if (
          isConflict &&
          ctrl.compliance?.interestDisclosure?.isConflict?.name === YesNoOption.no.name
        ) {
          ctrl.compliance.interestDisclosure.comments = '';
          ctrl.compliance.interestDisclosure.lenderConflictOfInterest = false;
          ctrl.compliance.interestDisclosure.lenderConflictOfInterestComments = '';
          ctrl.compliance.interestDisclosure.referralConflictOfInterest = false;
          ctrl.compliance.interestDisclosure.referralConflictOfInterestComments = '';
          ctrl.compliance.interestDisclosure.otherConflictOfInterest = false;
          ctrl.compliance.interestDisclosure.otherConflictOfInterestComments = '';
        } else if (
          !isConflict &&
          ctrl.compliance?.productSuitability?.isUnsuitable?.name ===
            ProductSuitabilityOption.not_unsuitable.name
        ) {
          ctrl.compliance.productSuitability.isProductInconsistent = false;
          ctrl.compliance.productSuitability.isApplicantComply = false;
        }
        ctrl.riskInsuranceComplianceChanges(true);
      };

      ctrl.getAnnouncement = () =>
        financeService.getMonthlyFinancialPositionAnnouncement({ workflow: ctrl.workflow });

      ctrl.financeMonthlyFinancialPositionEstimate = () => {
        ctrl.isMFP = false;
        financesService
          .monthlyFinancialPosition({ idTicket: ctrl.idTicket || '' })
          .then((res) => {
            if (res?.status && !_.isEmpty(res?.compliance)) {
              ctrl.compliance = RiskInsuranceCompliance.build(res?.compliance);
              const data = {
                compliance: ctrl.compliance
              };
              ctrl.onChanged({ data });
            }
            ctrl.isProcessing = false;
          });
      };

      ctrl.saveRiskInsuranceVerificationsIdentities = (identity) => {
        if (!_.isEmpty(identity)) {
          const idx = _.findIndex(
            ctrl.compliance?.verifications?.identities || [],
            (i) => i?.idContact === identity?.idContact
          );
          if (idx > -1) {
            ctrl.compliance.verifications.identities.splice(idx, 1);
            ctrl.compliance.verifications.identities.splice(idx, 0, identity);
          } else {
            ctrl.compliance.verifications.identities.push(identity);
          }
          ctrl.riskInsuranceComplianceChanges(true);
        }
      };

      ctrl.riskInsuranceComplianceChanges = _.debounce((isSilent) => {
        if (!isSilent) {
          ctrl.isMFP = true;
        }
        ctrl.saveRiskInsuranceCompliance();
      }, 3000);

      ctrl.saveRiskInsuranceCompliance = () => {
        ctrl.isProcessing = ctrl.isMFP;
        const data = {
          compliance: ctrl.compliance,
          rICD: ctrl.isMFP ? 'riskInsuranceCompliance' : ''
        };
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'riskInsuranceCompliance') {
          ctrl.financeMonthlyFinancialPositionEstimate();
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
